/**
 * @desc 待审核信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CustomsClearanceDSHRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/dshCustomsClearance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
